<template>
  <div class="direction">
    <LKRoadmapsFeedCardDirectionUp
      :node="node"
      v-on="$listeners || {}"
    />

    <LKRoadmapsFeedToggleLine
      :active="node.isActive"
      :loading="node.loading"
      label="Показать Меры"
      class="mod--events"
      @click.native="onLoadChildren"
    />

    <LKToggleContainer
      :active="node.isActive"
      class="event-wrapper"
    >
      <CardEvent
        v-for="(item, index) in node.children"
        :key="item.data.id"
        :node="item"
        :readonly="node.data.is_confirmed || isCoordinator"
        :load-children="loadChildren"
        :class="{
          'mod--last': index === node.children.length - 1,
        }"
        v-on="$listeners || {}"
      />

      <div
        v-if="!node.children.length"
        class="text-md"
        v-text="'Список пуст'"
      />
    </LKToggleContainer>
  </div>
</template>

<script>
import { loadChildrenMixin } from '../mixins'

import LKToggleContainer from '@/components/lk/LKToggleContainer.vue'
import CardEvent from '../CardEvent/LKRoadmapsFeedCardEvent.vue'
import LKRoadmapsFeedToggleLine from '../ui/LKRoadmapsFeedToggleLine.vue'
import LKRoadmapsFeedCardDirectionUp from './LKRoadmapsFeedCardDirectionUp.vue'


export default {
  name: 'LKRoadmapsFeedDirection',
  inject: [
    'isAdresat',
    'isCurator',
    'isCoordinator',
  ],
  components: {
    LKToggleContainer,
    CardEvent,
    LKRoadmapsFeedToggleLine,
    LKRoadmapsFeedCardDirectionUp,
  },
  mixins: [
    loadChildrenMixin,
  ],
  inheritAttrs: false,
}
</script>
